import { createSlice } from "@reduxjs/toolkit";
import { resetState } from "../../layout/header";

const initialState = {
  auth: false,
  formRendererState: {},
  version: "",
  versionDate: "",
  formRendererValidation: {
    date: false,
    select: false,
  },
  profileData: {},
  loading: false,
  organizationId: "",
  entityId: "",
  isFirstLogin: null,
  profileJson: "",
  customerData: {},
  agName: "",
  modalShow: false,
  personalDetailState: "",
  trigger: {
    filterButton: false,
  },
  pagination: {
    totalCount: 0,
    page: 0,
    size: 10,
  },
  agDetails: {},
  // getViewMasterData's `renderer` flag: 1 = @craft-form/renderer drives the
  // proposal form's step navigation, 0/absent = the legacy hand-rolled path.
  rendererVersion: 0,
};

const commonSlice = createSlice({
  name: "common",
  initialState: initialState,
  reducers: {
    setRendererFormState(state, action) {
      switch (action.payload.type) {
        case "checkbox":
          const updatedState = {
            ...state,
            formRendererState: {
              ...state.formRendererState,
              [action.payload.name]: action.payload.binary
                ? action.payload.checked
                  ? 0
                  : 1
                : action.payload.checked,
            },
          };
          return updatedState;
        default:
          const key = action.payload.key;
          const value = action.payload.value;
          state.formRendererState = {
            ...state.formRendererState,
            [key]: value,
          };
      }
    },
    setVersion(state, action) {
      state.version = action.payload;
    },
    setVersionDate(state, action) {
      state.versionDate = action.payload;
    },
    resetFormState: (state) => {
      state.formRendererState = {};
    },
    setSelectValidError(state, action) {
      state.formRendererValidation.select = action.payload;
    },
    setDateValidError(state, action) {
      state.formRendererValidation.date = action.payload;
    },
    updateRendererFormState(state, action) {
      state.formRendererState = action.payload;
    },
    setProfileData: (state, action) => {
      state.profileData = action.payload;
    },
    setAuth(state, action) {
      state.auth = action.payload;
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setOrganizationId: (state, action) => {
      state.organizationId = action.payload;
    },
    setEntityId: (state, action) => {
      state.entityId = action.payload;
    },
    setIsFirstLogin: (state, action) => {
      state.isFirstLogin = action.payload;
    },
    setProfileJson: (state, action) => {
      state.profileJson = action.payload;
    },
    setCustomerData: (state, action) => {
      state.customerData = action.payload;
    },
    setAgName: (state, action) => {
      state.agName = action.payload;
    },

    openModal(state, action) {
      state.modalShow = action.payload;
    },
    setPersonalDetailState: (state, action) => {
      state.personalDetailState = action.payload;
    },
    resetIsFirstTimeState: (state) => {
      state.isFirstLogin = initialState.isFirstLogin;
    },
    RenderPage(state) {
      state.triggerRender = !state.triggerRender;
    },
    setPaginationTotalCount(state, action) {
      state.pagination.totalCount = action.payload;
    },
    setPaginationRowsPerPage(state, action) {
      state.pagination.size = action.payload;
    },
    setPaginationPageNumber(state, action) {
      state.pagination.page = action.payload;
    },
    setAgDetails(state, action) {
      state.agDetails = action.payload;
    },
    // Kept separate from setRendererFormState, which is a field-level reducer
    // keyed by {key, value} and would drop a whole API response on the floor.
    setRendererVersion(state, action) {
      state.rendererVersion = Number(action.payload) || 0;
    },
  },
});
export const {
  setRendererFormState,
  setVersion,
  setVersionDate,
  resetFormState,
  setSelectValidError,
  setDateValidError,
  updateRendererFormState,
  setProfileData,
  setAuth,
  setLoading,
  setOrganizationId,
  setEntityId,
  setIsFirstLogin,
  setProfileJson,
  setCustomerData,
  setAgName,
  openModal,
  setPersonalDetailState,
  resetIsFirstTimeState,
  RenderPage,
  setPaginationTotalCount,
  setPaginationRowsPerPage,
  setPaginationPageNumber,
  setAgDetails,
  setRendererVersion,
} = commonSlice.actions;

export default commonSlice.reducer;
